import _extends from "@babel/runtime-corejs3/helpers/extends";
import _defineProperty from "@babel/runtime-corejs3/helpers/defineProperty";
import React from 'react';
import classNames from 'classnames';
import Icon from '../icon';
import Checkbox from '../checkbox';

var ListItem = function ListItem(props) {
  var _classNames;

  var renderedText = props.renderedText,
      renderedEl = props.renderedEl,
      item = props.item,
      checked = props.checked,
      disabled = props.disabled,
      prefixCls = props.prefixCls,
      onClick = props.onClick,
      showRemove = props.showRemove,
      onRemove = props.onRemove;
  var className = classNames((_classNames = {}, _defineProperty(_classNames, "".concat(prefixCls, "-content-item"), true), _defineProperty(_classNames, "".concat(prefixCls, "-content-item-disabled"), disabled || item.disabled), _defineProperty(_classNames, "".concat(prefixCls, "-content-item-checked"), checked), _classNames));
  var title;

  if (typeof renderedText === 'string' || typeof renderedText === 'number') {
    title = String(renderedText);
  }

  var liProps = {
    className: className,
    title: title
  };
  var labelNode = /*#__PURE__*/React.createElement("span", {
    className: "".concat(prefixCls, "-content-item-text")
  }, renderedEl);

  if (showRemove) {
    return /*#__PURE__*/React.createElement("li", _extends({}, liProps), labelNode, /*#__PURE__*/React.createElement("span", {
      className: "".concat(prefixCls, "-content-item-remove"),
      onClick: function onClick() {
        return onRemove && onRemove(item);
      }
    }, /*#__PURE__*/React.createElement(Icon, {
      type: "close-solid"
    })));
  } // Default click to select


  liProps.onClick = function (e) {
    if (disabled || item.disabled) return;
    e.preventDefault();
    onClick(item);
  };

  return /*#__PURE__*/React.createElement("li", _extends({}, liProps), /*#__PURE__*/React.createElement(Checkbox, {
    checked: checked,
    disabled: disabled || item.disabled
  }), labelNode);
};

export default /*#__PURE__*/React.memo(ListItem);